import {
    ViewApi,
    WebApiViewDtoCreateViewDto,
    WebApiViewDtoUpdateViewDto
} from "../Repository/eventbookyapi";
import { GetApiConfiguration } from "./ServiceConfiguration";

export abstract class ViewService {
    // Create a new membership product
    public static CreateView = async (request: WebApiViewDtoCreateViewDto) => {
        return new ViewApi(GetApiConfiguration()).apiViewPost({
            webApiViewDtoCreateViewDto: request
        });
    };

    // Get all membership products
    public static GetAllViews = async () => {
        return new ViewApi(GetApiConfiguration()).apiViewGet();
    };

    // Note: Get by ID is not available in the API - you'll need to filter from GetAllViews
    // or the API needs to be updated to include a GET by ID endpoint

    // Update an existing membership product
    public static UpdateView = async (viewId: number, request: WebApiViewDtoUpdateViewDto) => {
        return new ViewApi(GetApiConfiguration()).apiViewIdPut({
            id: viewId,
            webApiViewDtoUpdateViewDto: request
        });
    };

    // Delete a membership product
    public static DeleteView = async (viewId: number) => {
        return new ViewApi(GetApiConfiguration()).apiViewIdDelete({
            id: viewId
        });
    };
};
